import MUIDrawer, {
  DrawerProps as MUIDrawerProps,
} from "@material-ui/core/Drawer";

export type DrawerProps = {} & MUIDrawerProps;

export default MUIDrawer;
